import { render, staticRenderFns } from "./Releasedates.vue?vue&type=template&id=444c667c&scoped=true&"
import script from "./Releasedates.vue?vue&type=script&lang=js&"
export * from "./Releasedates.vue?vue&type=script&lang=js&"
import style0 from "./Releasedates.vue?vue&type=style&index=0&id=444c667c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444c667c",
  null
  
)

export default component.exports